import {DateRange} from './date-range';
import {PresetDateRange} from './presets';
import {DateRangeType, TimeUnit} from './types';

// `satisfies` rather than a `TimeUnit[]` annotation: the annotation would widen
// each element back to the full TimeUnit enum, and consumers rely on the literal
// member union (copilot's metric date schema types the engine wire against it).
export const UNIFIED_UNITS = [
  TimeUnit.Minute,
  TimeUnit.Hour,
  TimeUnit.Day,
  TimeUnit.Week,
  TimeUnit.Month,
  TimeUnit.Quarter,
] as const satisfies readonly TimeUnit[];
export class UnifiedWithPresetsDateRange extends DateRange {
  public static get presets(): PresetDateRange[] {
    return [
      PresetDateRange.Today,
      PresetDateRange.Yesterday,
      PresetDateRange.Last7Days,
      PresetDateRange.Last30Days,
      PresetDateRange.Last3Months,
      PresetDateRange.Last6Months,
      PresetDateRange.Last12Months,
    ];
  }

  public getDateRangeTypeOptions() {
    return [DateRangeType.RelativeAfter, DateRangeType.Between, DateRangeType.Since, DateRangeType.On];
  }

  public getTimeUnitOptions(): TimeUnit[] {
    return [...UNIFIED_UNITS];
  }

  public canUseRolling(): boolean {
    return [DateRangeType.Between, DateRangeType.On].includes(this.type);
  }

  public isRolling(): boolean {
    return Boolean(this.rolling);
  }
}
